import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../login/login.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  user_email: any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router
  ) { }

  ngOnInit() {
  }

  onForgot() {
    this._globalService.global_loader = true;
    this._globalService.forgot(this.user_email)
      .then((res) => {
        // console.log(`res ${res}`);
        this._globalService.global_loader = false;
        this._globalService.openSnackBar('Email has been sent to at your mail', 'Dismiss');
      })
      .catch((err) => {
      //  console.log(`error ${err}`);
       this._globalService.global_loader = false;
        this._globalService.openSnackBar(err, 'Dismiss');
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/forgot-password/forgot-password.component.ts